export default class ApiError extends Error {
  code = "";
  constructor(code: string) {
    super();
    this.code = code;
  }
}
